(function () {
  window._GROWTHHERO_CONFIG = {
    partner_panel_core: {
      top_bar_background: "#d0021b",
      background: "#f4f6f8",
      custom_css: "",
      public_theme_name: "default",
      primary_button_background: "#6371c7",
    },
    partner_public: {
      header:
        '\u003ctable style="border-collapse: collapse; width: 100%; margin-left: auto; margin-right: auto; height: 68px;" border="0"\u003e\u003ctbody\u003e\u003ctr style="height: 68px;"\u003e\u003ctd style="width: 5.28093%; height: 68px;"\u003e\u003cimg src="/shop-icon.png" alt="" width="88" height="90" /\u003e\u003c/td\u003e\u003ctd style="width: 3.92062%;"\u003e\u003cspan style="font-size: 18pt;"\u003e\u0026nbsp;\u003c/span\u003e\u003c/td\u003e\u003ctd style="width: 90.7984%; height: 68px;"\u003e\u003cspan style="font-size: 18pt;"\u003ePantys\u003c/span\u003e\u003c/td\u003e\u003c/tr\u003e\u003c/tbody\u003e\u003c/table\u003e',
    },
    partner_registration: { subheader: "", footer: "", additional_info: "" },
    partner_login: { subheader: "", footer: "" },
    referral_page: {
      header:
        '\u003ch2 style="font-size: 62px; font-weight: 100; line-height: 62px; margin: 0; padding: 0; padding-bottom: 30px;"\u003eInvite a friend and get $5 off\u003c/h2\u003e\u003ch3 style="font-size: 18px; font-weight: 400; margin: 0; padding: 0;"\u003eSend a friend $5 off their first purchase over $50 and earn $5 in credit!\u003c/h3\u003e',
      footer: "",
    },
    partner_homepage: {
      welcome_text:
        "This is your main dashboard. Use the referral link to promote the store. When a person from your link purchases something you will receive the reward displayed below.",
      main_card_top_text: "",
      main_card_bottom_text: "",
      program_details_bottom_text: "",
    },
    partner_payments: {
      paypal_info:
        "Payment using PayPal is made by the affiliate program owner manually. Typically the payment is running once a month.",
    },
    partner_network: {
      description:
        "Grow your partner network, invite others and earn a commission from every sale.",
    },
    partner_not_active: {
      body: '\u003cdiv style="display: flex; justify-content: center;"\u003e\u003cimg src="/Post.svg" alt="Contact" height="400" /\u003e\u003c/div\u003e',
    },
    translations: {},
    plan_limit_reached: false,
    smart_links: { "": "/" },
  };
  window._GROWTHHERO_AUDIENCES = [
    {
      id: 29418,
      conditions: [[[{ type: "is_mobile", matcher: "equal", value: "true" }]]],
      config: {},
    },
    {
      id: 29419,
      conditions: [[[{ type: "is_tablet", matcher: "equal", value: "true" }]]],
      config: {},
    },
    {
      id: 29420,
      conditions: [[[{ type: "is_desktop", matcher: "equal", value: "true" }]]],
      config: {},
    },
  ];
  window._GROWTHHERO_EXPERIMENTS = {};
  window._GROWTHHERO_GROUP_COOKIES = { 23857: 30, 23858: 30 };
})();
